import Separator from '../components/Separator';
import classList from '../utils/classList';

/**
 * This type represents an element of a list returned by `ItemList.toArray()`,
 * coupled with some static properties used on various components.
 */

function isVnode(item) {
  return typeof item === 'object' && item !== null && 'tag' in item;
}
function isSeparator(item) {
  return isVnode(item) && item.tag === Separator;
}
function withoutUnnecessarySeparators(items) {
  const newItems = [];
  let prevItem;
  items.filter(Boolean).forEach((item, i) => {
    if (!isSeparator(item) || prevItem && !isSeparator(prevItem) && i !== items.length - 1) {
      prevItem = item;
      newItems.push(item);
    }
  });
  return newItems;
}

/**
 * The `listItems` helper wraps an array of components in the provided tag,
 * stripping out any unnecessary `Separator` components.
 *
 * By default, this tag is an `<li>` tag, but this is customisable through the
 * second function parameter, `customTag`.
 */
export default function listItems(rawItems, customTag, attributes) {
  if (customTag === void 0) {
    customTag = 'li';
  }
  if (attributes === void 0) {
    attributes = {};
  }
  const items = rawItems instanceof Array ? rawItems : [rawItems];
  const Tag = customTag;
  return withoutUnnecessarySeparators(items).map(item => {
    const classes = [item.itemName && `item-${item.itemName}`];
    if (isVnode(item) && item.tag.isListItem) {
      item.attrs = item.attrs || {};
      item.attrs.key = item.attrs.key || item.itemName;
      item.key = item.attrs.key;
      return item;
    }
    if (isVnode(item)) {
      classes.push(item.attrs?.itemClassName || item.itemClassName);
      if (item.tag.isActive?.(item.attrs)) {
        classes.push('active');
      }
    }
    const key = isVnode(item) && item?.attrs?.key || item.itemName;
    return m(Tag, Object.assign({
      className: classList(classes),
      key: key
    }, attributes), item);
  });
}
flarum.reg.add('core', 'common/helpers/listItems', listItems);